import React from 'react';
import MultiTaskResponse from 'react-scale/components/Task/MultiTaskResponse';
import { makeStyles } from 'design-system/styles';

interface EmbeddedTaskResponseProps {
  id: string;
  attachmentBody?: any;
}

const useEmbeddedTaskResponseStyles = makeStyles({
  container: {
    height: '100%',
    background: 'white',
    display: 'flex',
    overflow: 'hidden',
  },
});

const EmbeddedTaskResponse: React.FC<EmbeddedTaskResponseProps> = ({ id, attachmentBody }) => {
  const classes = useEmbeddedTaskResponseStyles();

  return (
    <div className={classes.container}>
      {attachmentBody && (
        <MultiTaskResponse
          key={id}
          subtask={attachmentBody}
          responses={[
            {
              name: 'Response',
              response: attachmentBody.response,
            },
          ]}
        />
      )}

      {!attachmentBody && <div>Could not find attachment.</div>}
    </div>
  );
};

export default EmbeddedTaskResponse;
